import { useMediaQuery } from "@mui/material";
import FormInputs from "../../../../../../components/UI/FormInputs";
import { isSet } from "../../../../../../utils/commonUtils";

const CheckboxGroup = ({
  isLabel,
  itemIndex,
  column,
  options,
  label,
  formData,
  combineToKey,
  name,
  singleSelect, // when true: checkboxes look, but only one selectable; value stored in name
  singleSelectDefault, // when singleSelect and user unchecks, set to this (e.g. "no_action_needed")
  disabled,   // 👈 NEW PROP (applies to all checkboxes)
  showContainerBorder,
  isVertical,
  layout = "horizontal",
  columns, // number of columns for grid layout (e.g. 4)
  ...props
}) => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const effectiveColumns = typeof columns === "number" && columns > 0 && isMobile ? 1 : columns;
  const selected = combineToKey
    ? (formData[combineToKey] ? formData[combineToKey].split(",") : [])
    : [];
  const singleValue = name && formData[name];
  const hasContainerBorder = isSet(showContainerBorder, true);
  const isStackedLayout = layout === "stacked";
  const isGridLayout = typeof effectiveColumns === "number" && effectiveColumns > 0;
  // When using grid, "other" option is rendered below the grid (full width)
  const gridOptions = isGridLayout
    ? options.filter((o) => o.name !== "other")
    : options;
  const otherOption = isGridLayout
    ? options.find((o) => o.name === "other")
    : null;

  const renderCheckbox = (optionItem, idx, className = "") => {
    const optionVal = optionItem.value ?? optionItem.name;
    const checked = singleSelect
      ? String(singleValue ?? "") === String(optionVal)
      : combineToKey
        ? selected.includes(optionItem.name)
        : isSet(formData[optionItem.name], false);

    return (
      <div
        className={`${
          isVertical
            ? "sh_formcheckwrap d-flex align-items-center mb-2 ml-0 pl-0"
            : isStackedLayout
              ? "form-check sh_formcheckwrap form-check-inline d-inline-flex ml-0 pl-0"
              : "form-check sh_formcheckwrap form-check-inline d-inline-flex"
        } ${className}`}
        key={optionItem.name + "_" + idx}
      >
        <FormInputs
          {...props}
          type="Checkbox"
          {...optionItem}
          value={checked}
          disabled={disabled || optionItem.disabled}
          id={(optionItem.name || optionVal) + "_" + idx}
          changeHandler={(val) => {
            if (disabled || optionItem.disabled) return;

            if (singleSelect && name) {
              // ✅ single-select: only one checkbox can be checked; store value in name
              props.changeHandler(name, val ? optionVal : (singleSelectDefault ?? ""));
            } else if (combineToKey) {
              let newSelected = [...selected];
              if (val) {
                if (!newSelected.includes(optionItem.name)) {
                  newSelected.push(optionItem.name);
                }
              } else {
                newSelected = newSelected.filter((item) => item !== optionItem.name);
              }
              props.changeHandler(combineToKey, newSelected.join(","));
            } else {
              props.changeHandler(optionItem.name, val);
            }
          }}
        />
        <label
          className={`form-check-label font-weight-bold1 pl-2 ${
            disabled || optionItem.disabled ? "opacity-50" : ""
          }`}
          htmlFor={(optionItem.name || optionVal) + "_" + idx}
        >
          {optionItem.label}
        </label>
      </div>
    );
  };

  return (
    <>
      <div className={`${column} ${hasContainerBorder ? "border border-left-0" : ""} py-1`} key={itemIndex}>
        <div className={`form-group ${isStackedLayout ? "mb-0 align-items-center" : "row mb-0 align-items-center"}`}>
          {isSet(isLabel, true) === false ? (
            <></>
          ) : (
            <label
              className="col-sm-6 f-400 text-sm text-truncate mb-0 opacity-75"
              title={label}
            >
              {label}
            </label>
          )}

          <div
            className={`${
              isSet(isLabel, true) === false ? "col-sm-12" : isStackedLayout ? "col-12" : "col-sm-6"
            } ${isVertical ? "d-flex flex-column align-items-start" : ""}`}
            style={isGridLayout ? { display: "grid", gridTemplateColumns: `repeat(${effectiveColumns}, 1fr)`, gap: "0.5rem 1rem", alignItems: "start" } : undefined}
          >
            {isGridLayout ? (
              <>
                {gridOptions.map((optionItem, idx) => renderCheckbox(optionItem, idx))}
                {otherOption ? (
                  <div key="other" style={{ gridColumn: "1 / -1" }}>
                    {renderCheckbox(otherOption, options.indexOf(otherOption), "mb-2")}
                  </div>
                ) : null}
              </>
            ) : (
              options.map((optionItem, idx) => renderCheckbox(optionItem, idx))
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckboxGroup;